import { render } from "./PrimaryButton.vue?vue&type=template&id=0aec6ed8&scoped=true"
import script from "./PrimaryButton.vue?vue&type=script&lang=js"
export * from "./PrimaryButton.vue?vue&type=script&lang=js"

import "./PrimaryButton.vue?vue&type=style&index=0&id=0aec6ed8&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aec6ed8"]])

export default __exports__